import { encode } from "uqr";

/**
 * The QR code for `value` as one SVG path, in module units. Kept apart from
 * the component so the encoding can be asserted without a DOM, and so the
 * phone app can draw the same path with `react-native-svg` (ISSUE-1339).
 *
 * Error correction `M` (about 15% of the code can be smudged or covered and
 * it still scans), which is what a code held up on a phone across a table
 * needs. The border is the four-module quiet zone the QR spec asks for, so a
 * code drawn on any background still scans.
 */
export const QR_QUIET_ZONE = 4;

export type typeQrPath = {
  /** Width and height of the whole code, quiet zone included, in modules. */
  size: number;
  /** One `d` attribute covering every dark module. */
  path: string;
};

export function buildQrPath(value: string): typeQrPath {
  const qr = encode(value, { ecc: "M", border: QR_QUIET_ZONE });
  let path = "";
  qr.data.forEach((row, y) => {
    row.forEach((isDark, x) => {
      if (isDark) path += `M${x} ${y}h1v1h-1z`;
    });
  });
  return { size: qr.size, path };
}
